module.exports = __webpack_public_path__ + "img/salewa.69251811.png";